<template>

  <div :style="'height:667px;background-color:'+data.style.backgroundColor">
      <swiper 
    :slides-per-view="1" 
    autoplay
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    style="height:626px"
    @slideChange="onSlideChange">

    <swiper-slide v-for="(item,index) in data.data" :key="index">
      <img :src="item.imgUrl?item.imgUrl:require('@/assets/images/normal.png')" alt="" class="width100">
    </swiper-slide>
  </swiper>
  <img src="@/assets/images/scan/customer_10000010/homback.png" alt="" class="width-115 height-62" style="position: absolute;
    right:14px;
    bottom: 100px;z-index:10">
  </div>
</template>
<script>
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/swiper.less";
import "swiper/components/navigation/navigation.less";
import "swiper/components/pagination/pagination.less";
import "swiper/components/scrollbar/scrollbar.less";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
export default {
  props: { data: Object },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const onSwiper = (swiper) => {
    };
    const onSlideChange = () => {
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
};
</script>
<style lang="less" scoped>

</style>